import { sanitizeAuthRedirectUrl } from "@/lib/core/auth-protocol/auth-redirect";

function referrerRedirectUrl() {
    if (typeof document === "undefined" || typeof window === "undefined") {
        return undefined;
    }
    try {
        const url = new URL(document.referrer);
        return url.origin === window.location.origin
            ? sanitizeAuthRedirectUrl(`${url.pathname}${url.search}${url.hash}`)
            : undefined;
    } catch {
        return undefined;
    }
}

export function currentLocationAuthRedirectUrl(
    location?: Pick<Location, "hash" | "pathname" | "search">,
) {
    const source =
        location ??
        (typeof window === "undefined" ? undefined : window.location);
    if (!source) return "/";
    return (
        sanitizeAuthRedirectUrl(
            `${source.pathname}${source.search}${source.hash}`,
        ) ?? "/"
    );
}

export function resolveAuthPageRedirectUrl(redirectUrl?: string) {
    return sanitizeAuthRedirectUrl(redirectUrl) ?? referrerRedirectUrl() ?? "/";
}

export function oauthCallbackErrorMessage(
    error: string | string[] | undefined,
) {
    const value = Array.isArray(error) ? error[0] : error;
    return value === "oauth"
        ? "Google sign-in didn't complete. Please try again."
        : null;
}

export function authRedirectSearch(
    search: Record<string, string | string[] | undefined>,
) {
    const redirect_url = sanitizeAuthRedirectUrl(search.redirect_url);
    const error = oauthCallbackErrorMessage(search.error) ? "oauth" : undefined;
    return {
        ...(redirect_url ? { redirect_url } : {}),
        ...(error ? { error } : {}),
    };
}

export function withDefaultAuthRedirect<
    T extends {
        fallbackRedirectUrl?: string | null;
        forceRedirectUrl?: string | null;
        signInFallbackRedirectUrl?: string | null;
        signUpFallbackRedirectUrl?: string | null;
    },
>(
    options: T,
    currentUrl = currentLocationAuthRedirectUrl(),
): T & {
    fallbackRedirectUrl: string;
    signInFallbackRedirectUrl: string;
    signUpFallbackRedirectUrl: string;
} {
    const fallbackRedirectUrl =
        sanitizeAuthRedirectUrl(options.fallbackRedirectUrl) ??
        sanitizeAuthRedirectUrl(options.forceRedirectUrl) ??
        sanitizeAuthRedirectUrl(currentUrl) ??
        "/";
    return {
        ...options,
        fallbackRedirectUrl,
        signInFallbackRedirectUrl:
            sanitizeAuthRedirectUrl(options.signInFallbackRedirectUrl) ??
            fallbackRedirectUrl,
        signUpFallbackRedirectUrl:
            sanitizeAuthRedirectUrl(options.signUpFallbackRedirectUrl) ??
            fallbackRedirectUrl,
    };
}
